import { useMemo } from 'react'
import { encode } from 'uqr'

/**
 * QR code do segundo fator, desenhado PELA SPA (S32-2; ADR-0024 D5; ADR-0030 D4:
 * o backend nunca produz imagem e nenhuma lib de QR entra no `pyproject.toml`).
 *
 * Biblioteca: `uqr` 0.1.3 (unjs, MIT, ZERO dependencias, versao travada), so o
 * CODIFICADOR (`encode` -> matriz de booleanos). O desenho e React puro: um
 * `<rect>` por modulo escuro -- sem `dangerouslySetInnerHTML`, sem canvas, sem
 * imagem gerada, e a URI (que carrega o segredo) nunca vira texto nem atributo.
 *
 * `ecc: 'M'` (15% de recuperacao) e `border: 4` (a zona de silencio que o padrao
 * QR pede; celulares leem pior com borda menor). Medido fora do repositorio
 * (s32): URI de 124 caracteres -> versao 8, 57 modulos, decodificada igual por um
 * leitor independente.
 */
export function TotpQr({ uri, label, size = 220 }: { uri: string; label?: string; size?: number }) {
  const qr = useMemo(() => encode(uri, { ecc: 'M', border: 4 }), [uri])
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${qr.size} ${qr.size}`}
      shapeRendering="crispEdges"
      style={{ background: '#FFFFFF', display: 'block' }}
    >
      {qr.data.flatMap((row, y) =>
        row.map((on, x) =>
          on ? <rect key={`${x}-${y}`} data-m="" x={x} y={y} width={1} height={1} fill="#000000" /> : null,
        ),
      )}
    </svg>
  )
}
